import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache: true
};
const noCacheMeta = {
    auth: false
};

// noinspection JSAnnotator
export default {
    path: '/bpm/my',
    name: 'userOffice',
    redirect: {
        name: 'todoTaskList'
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/bpm/my/todoTaskList/:instDefKey',
            name: 'todoTaskList',
            meta: {
                auth: false,
                cache: true,
                // title: '$t:menu.TODOTaskList',
                title: '待办事项',
            },
            component: () => import('@/pages/bpm/my/todoTaskList.vue')
        },
        {
            path: '/bpm/my/approveHistoryList/:instDefKey',
            name: 'approveHistoryList',
            meta: {
                ...meta,
                // title: '$t:menu.approveHistoryList',
                title: '办理历史',
            },
            component: () => import('@/pages/bpm/my/approveHistoryList.vue')
        },
        {
            path: '/bpm/my/xxlb',
            name: 'xxlb',
            meta: {
                ...meta,
                // title: '$t:menu.xxlb',
                title: '消息列表',
            },
            component: () => import('@/pages/bpm/my/xxlb.vue')
        },
        {
            path: '/bpm/my/draft/:instDefKey',
            name: 'myDraft',
            meta: {
                ...meta,
                title: '我的草稿',
            },
            component: () => import('@/pages/bpm/my/draftList.vue')
        },
        {
            path: '/bpm/my/startFlow',
            name: 'startFlow',
            meta: {
                ...meta,
                title: '发起申请',
            },
            component: title => import('@/pages/bpm/my/startFlowList.vue')
        },
        {
            path: '/bpm/my/applyHistory/:instDefKey',
            name: 'applyHistoryList',
            meta: {
                auth: false,
                cache: true,
                // title: '$t:menu.applyHistory',
                title: '申请历史',
            },

            component: () => import('@/pages/bpm/my/applyHistoryList.vue')
        },
        {
            path: '/bpm/instance/instanceDetail/:id',
            name: 'instanceDetail',
            meta: {
                auth: false,
                cache: false,
                title: '流程详情',
            },
            component: () => import('@/pages/bpm/instance/instanceDetail.vue')
        },
        {
            path: '/bpm/instance/instanceDetailView/:id',
            name: 'instanceDetailView',
            meta: {
                auth: false,
                cache: false,
                title: '流程查看',
            },
            component: () => import('@/pages/bpm/instance/instanceDetailView.vue')
        },
        {
            path: '/bpm/instance/start/:flowKey',
            name: 'definitionStart',
            meta: {
                ...meta,
                title: '发起流程',
            },
            component: () => import('@/pages/bpm/instance/start.vue')
        },
        {
            path: '/bpm/instance/taskComplete/:id',
            name: 'taskComplete',
            meta: {
                ...meta,
                title: '处理任务',
            },
            component: () => import('@/pages/bpm/instance/taskComplete.vue')
        },
        // {
        //     path: '/bpm/flowImage/:defId/:instId/:taskId', // taskId可不传
        //     name: 'flowImage',
        //     meta: {
        //         ...meta,
        //         title: '流程图',
        //     },
        //     component: () => import('@/components/ab-bpm/buttonDialogs/bpm-flow-image-dialog.vue')
        // },
        {
            path: '/bpm/flowImage/:defId/:instId',
            name: 'flowImage',
            meta: {
                ...meta,
                title: '流程图',
            },
            component: () => import('@/components/ab-bpm/buttonDialogs/bpm-flow-image-dialog.vue')
        },
        {
            path: '/bpm/instance/draftStart/:id',
            name: 'draftStart',
            meta: {
                ...meta,
                title: '启动草稿',
            },
            component: () => import('@/pages/bpm/instance/draftStart.vue')
        },
        {
            path: '/form/form/preview',
            name: 'form_preview',
            meta: {
                ...noCacheMeta,
                title: '表单预览',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/form/preview.vue')
        },
        {
            path: '/form/form/previe',
            name: 'form_previe',
            meta: {
                ...noCacheMeta,
                title: '表单预览',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/form/previe.vue')
        },
        {
            path: '/form/formCustSql/view/formCustSqlView.html',//为了跟设计平台的地址一致
            name: 'formCustSqlView',
            meta: {
                ...noCacheMeta,
                title: '自定义列表',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/custsql/formCustSqlView.vue')
        },
        {
            path: '/form/custDashboard/formCustDashboardView.html',//为了跟设计平台的地址一致
            name: 'formCustDashboardView',
            meta: {
                ...noCacheMeta,
                title: '自定义仪表盘',
                hideInMenu: true
            },
            component: () => import('@/pages/bpm/custdashboard/formCustDashboardView.vue')
        },
        {
            path: '/bpm/my/myDefinitionList/:instDefKey',
            name: 'myDefinitionList',
            meta: {
                ...meta,
                title: '发起申请',
            },
            component: () => import('@/pages/bpm/my/myDefinitionList.vue')
        },
        {
            path: '/bpm/my/carboncopyReceiveList',
            name: 'carboncopyReceiveList',
            meta: {
                ...meta,
                title: '转阅协办',
            },
            component: () => import('@/pages/bpm/my/carboncopyReceiveList.vue')
        },
        {
            path: '/bpm/my/carboncopySendList',
            name: 'carboncopySendList',
            meta: {
                ...meta,
                title: '我的协办',
            },
            component: () => import('@/pages/bpm/my/carboncopySendList.vue')
        },
        {
            path: '/bpm/my/distributeReceiveList',
            name: 'carboncopyDistributeReceiveList',
            meta: {
                ...meta,
                title: '公文阅读',
            },
            component: () => import('@/pages/bpm/my/carboncopyDistributeReceiveList.vue')
        },
        {
            path: '/bpm/my/carboncopyDistributeSendList',
            name: 'carboncopyDistributeSendList',
            meta: {
                ...meta,
                title: '我的分发',
            },
            component: () => import('@/pages/bpm/my/carboncopyDistributeSendList.vue')
        },
        {
            path: '/bpm/my/distributeDetail',
            name: 'distributeReceiveDetail',
            meta: {
                ...meta,
                title: '公文详情',
            },
            component: () => import('@/pages/bpm/my/carboncopyDistributeDetail.vue')
        },
        {
            path: '/bpm/plugin/userAgencyConfigList',
            name: 'userAgencyConfigList',
            meta: {
                ...meta,
                title: '代理设置',
            },
            component: () => import('@/pages/bpm/bpmplugin/userAgencyConfigList.vue')
        },
        {
            path: '/bpm/my/bpm/plugin/userAgencyConfigEdit',
            name: 'userAgencyConfigEdit',
            meta: {
                ...meta,
                title: '代理编辑',
            },
            component: () => import('@/pages/bpm/bpmplugin/userAgencyConfigEdit.vue')
        },
        {
            path: '/bpm/my/bpm/plugin/userAgencyLogList/:id',
            name: 'userAgencyLogList',
            meta: {
                ...noCacheMeta,
                title: '代理记录',
            },
            component: () => import('@/pages/bpm/bpmplugin/userAgencyLogList.vue')
        },
        {
            path: '/my/dailyPhrasesList',
            name: 'dailyPhrasesList',
            meta: {
                ...noCacheMeta,
                title: '用户常用语',
            },
            component: () => import('@/pages/bpm/my/dailyPhrasesList')
        },
        {
            path: '/my/dailyPhrasesEdit',
            name: 'dailyPhrases_add',
            meta: {
                ...noCacheMeta,
                title: '新增常用语'
            },
            component: () => import('@/pages/bpm/my/dailyPhrasesEdit')
        },
        {
            path: '/bpm/my/postTodo',
            name: 'postTodo',
            meta: {
                ...meta,
                title: '发文待办',
            },
            component: () => import('@/pages/bpm/my/postTodo.vue')
        },
        {
            path: '/bpm/my/postDraf',
            name: 'postDraf',
            meta: {
                ...meta,
                title: '发文草稿',
            },
            component: () => import('@/pages/bpm/my/postDraf.vue')
        },
        {
            path: '/bpm/my/postLaunch',
            name: 'postLaunch',
            meta: {
                ...meta,
                title: '发文发起',
            },
            component: () => import('@/pages/bpm/my/postLaunch.vue')
        },
        {
            path: '/bpm/my/postApprove',
            name: 'postApprove',
            meta: {
                ...meta,
                title: '发文已办',
            },
            component: () => import('@/pages/bpm/my/postApprove.vue')
        },
        {
            path: '/bpm/my/postToLaunch',
            name: 'postToLaunch',
            meta: {
                ...meta,
                title: '发文申请',
            },
            component: () => import('@/pages/bpm/my/postToLaunch.vue')
        },
        {
            path: '/bpm/my/reciveTodo',
            name: 'reciveTodo',
            meta: {
                ...meta,
                title: '收文待办',
            },
            component: () => import('@/pages/bpm/my/reciveTodo.vue')
        },
        {
            path: '/bpm/my/reciveApprove',
            name: 'reciveApprove',
            meta: {
                ...meta,
                title: '收文已办',
            },
            component: () => import('@/pages/bpm/my/reciveApprove.vue')
        },
        {
            path: '/bpm/my/reciveLaunch',
            name: 'reciveLaunch',
            meta: {
                ...meta,
                title: '收文发起',
            },
            component: () => import('@/pages/bpm/my/reciveLaunch.vue')
        },
        {
            path: '/bpm/my/reciveDraf',
            name: 'reciveDraf',
            meta: {
                ...meta,
                title: '收文草稿',
            },
            component: () => import('@/pages/bpm/my/reciveDraf.vue')
        },
        {
            path: '/bpm/my/reciveToLaunch',
            name: 'reciveToLaunch',
            meta: {
                ...meta,
                title: '收文申请',
            },
            component: () => import('@/pages/bpm/my/reciveToLaunch.vue')
        },
        {
            path: '/bpm/my/meetingPublish',
            name: 'meetingPublish',
            meta: {
                ...meta,
                title: '发起会议',
            },
            component: () => import('@/pages/bpm/my/meeting/meetingPublish.vue')
        },
        {
            path: '/bpm/my/meetingNew',
            name: 'meetingNew',
            meta: {
                ...meta,
                title: '新建会议',
            },
            component: () => import('@/pages/bpm/my/meeting/meetingNew.vue')
        },
        {
            path: '/bpm/my/tinymceEditor',
            name: 'tinymceEditor',
            meta: {
                ...meta,
                title: '新建会议',
            },
            component: () => import('@/pages/bpm/my/meeting/tinymceEditor.vue')
        },
        {
            path: '/bpm/my/meetings',
            name: 'meetings',
            meta: {
                ...meta,
                title: '我的会议',
            },
            component: () => import('@/pages/bpm/my/meeting/meetings.vue')
        },
        {
            path: '/bpm/my/meetingReport',
            name: 'meetingReport',
            meta: {
                ...meta,
                title: '议题报送',
            },
            component: () => import('@/pages/bpm/my/meeting/meetingReport.vue')
        },
        {
            path: '/bpm/my/meetingManage',
            name: 'meetingManage',
            meta: {
                ...meta,
                title: '议题管理',
            },
            component: () => import('@/pages/bpm/my/meeting/meetingManage.vue')
        },
        {
            path: '/bpm/my/meetingList',
            name: 'meetingList',
            meta: {
                ...meta,
                title: '会议统计',
            },
            component: () => import('@/pages/bpm/my/meeting/meetingList.vue')
        },


        {
            path: '/bpm/my/meetingUnitList',
            name: 'meetingUnitList',
            meta: {
                ...meta,
                title: '参会单位',
            },
            component: () => import('@/pages/bpm/my/meeting/meetingUnitList.vue')
        },
        {
            path: '/bpm/my/meetingTypeList',
            name: 'meetingTypeList',
            meta: {
                ...meta,
                title: '会议类型',
            },
            component: () => import('@/pages/bpm/my/meeting/meetingTypeList.vue')
        },
        {
            path: '/bpm/my/issues',
            name: 'issues',
            meta: {
                ...meta,
                title: '我的议题',
            },
            component: () => import('@/pages/bpm/my/meeting/issues.vue')
        },
        {
            path: '/bpm/my/leaveApply',
            name: 'leaveApply',
            meta: {
                ...meta,
                title: '审批查询',
            },
            component: () => import('@/pages/bpm/my/affair/leaveApply.vue')
        },
        {
            path: '/bpm/my/leaveDraft',
            name: 'leaveDraft',
            meta: {
                ...meta,
                title: '暂存待办',
            },
            component: () => import('@/pages/bpm/my/affair/leaveDraft.vue')
        },
        {
            path: '/bpm/my/leaveTodo',
            name: 'leaveTodo',
            meta: {
                ...meta,
                title: '待办审批',
            },
            component: () => import('@/pages/bpm/my/affair/leaveTodo.vue')
        },
        {
            path: '/bpm/my/leaveApprove',
            name: 'leaveApprove',
            meta: {
                ...meta,
                title: '已办审批',
            },
            component: () => import('@/pages/bpm/my/affair/leaveApprove.vue')
        },
        {
            path: '/bpm/my/leaveToLaunch',
            name: 'leaveToLaunch',
            meta: {
                ...meta,
                title: '发起审批',
            },
            component: () => import('@/pages/bpm/my/affair/leaveToLaunch.vue')
        },
        {
            path: '/bpm/my/tripApply',
            name: 'tripApply',
            meta: {
                ...meta,
                title: '出差申请',
            },
            component: () => import('@/pages/bpm/my/trip/tripApply.vue')
        },
        {
            path: '/bpm/my/tripDraft',
            name: 'tripDraft',
            meta: {
                ...meta,
                title: '出差草稿',
            },
            component: () => import('@/pages/bpm/my/trip/tripDraft.vue')
        },
        {
            path: '/bpm/my/tripTodo',
            name: 'tripTodo',
            meta: {
                ...meta,
                title: '出差待办',
            },
            component: () => import('@/pages/bpm/my/trip/tripTodo.vue')
        },
        {
            path: '/bpm/my/tripApprove',
            name: 'tripApprove',
            meta: {
                ...meta,
                title: '出差已办',
            },
            component: () => import('@/pages/bpm/my/trip/tripApprove.vue')
        },
        {
            path: '/bpm/my/tripToLaunch',
            name: 'tripToLaunch',
            meta: {
                ...meta,
                title: '出差申请',
            },
            component: () => import('@/pages/bpm/my/trip/tripToLaunch.vue')
        },
        {
            path: '/bpm/my/oaDocumentNumberReserveList',
            name: 'oaDocumentNumberReserveList',
            meta: {
                ...meta,
                title: '预留文号',
            },
            component: () => import('@/pages/bpm/my/document/oaDocumentNumberReserveList.vue')
        },

        {
            path: '/bpm/my/oaDocumentNumberInfoList',
            name: 'oaDocumentNumberInfoList',
            meta: {
                ...meta,
                title: '公文字号',
            },
            component: () => import('@/pages/bpm/my/document/oaDocumentNumberInfoList.vue')
        },

        {
            path: '/bpm/my/oaDocumentHeadTemplateList',
            name: 'oaDocumentHeadTemplateList',
            meta: {
                ...meta,
                title: '套红模板',
            },
            component: () => import('@/pages/bpm/my/document/oaDocumentHeadTemplateList.vue')
        },
        {
            path: '/bpm/my/oaDocFileList',
            name: 'oaDocFileList',
            meta: {
                ...meta,
                title: '档案管理',
            },
            component: () => import('@/pages/bpm/my/document/oaDocFileList.vue')
        },
        {
            path: '/bpm/my/recode',
            name: 'recode',
            meta: {
                auth: false,
                cache: true,
                title: '归档页'
            },
            component: () => import('@/pages/dashboard/ifame/recode.vue')
        },
        {
            path: '/bpm/my/oaDocIssueList',
            name: 'oaDocIssueList',
            meta: {
                ...meta,
                title: '发文查询',
            },
            component: () => import('@/pages/bpm/my/document/oaDocIssueList.vue')
        },
        {
            path: '/bpm/my/oaDocReceiveList',
            name: 'oaDocReceiveList',
            meta: {
                ...meta,
                title: '收文查询',
            },
            component: () => import('@/pages/bpm/my/document/oaDocReceiveList.vue')
        },

        {
            path: '/bpm/my/message',
            name: 'message',
            meta: {
                ...meta,
                title: '发送短信',
            },
            component: () => import('@/pages/bpm/my/shortmessage/message.vue')
        },
        {
            path: '/bpm/my/smjob',
            name: 'smjob',
            meta: {
                ...meta,
                title: '短信任务',
            },
            component: () => import('@/pages/bpm/my/shortmessage/SmjobList.vue')
        },
        {
            path: '/bpm/my/smbox',
            name: 'smbox',
            meta: {
                ...meta,
                title: '短信记录',
            },
            component: () => import('@/pages/bpm/my/shortmessage/SmboxList.vue')
        }

    ]
};
